// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1W8h0","calendarButtons":"ClockData_calendarButtons__1Hk7a"};